import formatDate from '@utils/format-date'
import {
    cloneDeep
} from 'lodash'

export default {
    components: {

    },
    filters: {
    },
    data() {
        return {
            signDialogVisible: false, // 發票資訊的視窗開關
            signDialogVisiableResolve: () => { }, // 發票流程resolve
            signDialogVisiableReject: () => { }, // 發票流程reject
            invoiceStoreData: {} // 發票儲存資料
        }
    },
    computed: {

    },
    watch: {

    },
    created() {

    },
    methods: {
        /**
          * @description 設定發票資訊
          */
        async setInvoiceInfo(submitData, type) {
            if (submitData.paymentStatus === 'UNPAID' || this.$invoiceSettingNumber() === 0 ||
                (this.$invoiceSettingNumber() === 1 && this.isPriceZero(submitData, type))) {
                return new Promise((resolve, reject) => {
                    resolve()
                })
            } else {
                return new Promise((resolve, reject) => {
                    this.signDialogVisible = true
                    this.signDialogVisiableResolve = () => {
                        resolve()
                    }
                    this.signDialogVisiableReject = () => {
                        reject(new Error('stop'))
                    }
                })
            }
        },
        /**
         * @description 價錢0元不開窗
         */
        isPriceZero(submitData, type) {
            if (type === 'deposit-form') {
                const { params } = submitData
                // 找出來價錢為0，return true，代表讓其繼續走下去
                let actualDepositPlan = params.find(item => item.type === 'deposit-plan')
                if (actualDepositPlan && actualDepositPlan.price === 0) {
                    return true
                } else {
                    return false
                }
            }
            if (type === 'deposit-detail') {
                const { payTotal } = submitData
                // 找出來價錢為0，return true，代表讓其繼續走下去
                if (payTotal === 0) {
                    return true
                } else {
                    return false
                }
            }
            if (type === 'prepaid-form') {
                const { params } = submitData
                // 找出來價錢為0，return true，代表讓其繼續走下去
                let actualDepositPlan = params.find(item => item.type === 'prepaid-plan')
                if (actualDepositPlan && actualDepositPlan.price === 0) {
                    return true
                } else {
                    return false
                }
            }
            if (type === 'prepaid-detail') {
                const { priceTotal } = submitData
                // 找出來價錢為0，return true，代表讓其繼續走下去
                if (priceTotal === 0) {
                    return true
                } else {
                    return false
                }
            }
            return false // 預設是要開窗
        },
        /**
           * @description 純關閉發票視窗
           */
        closeSignature() {
            this.signDialogVisiableReject()
            this.signDialogVisible = false
        },
        /**
     * @description 真正儲存後，關發票窗，並且往下儲存
     */
        closeSignaturDialog(type, submitData) {
            this.invoiceStoreData = cloneDeep(submitData)
            this.signDialogVisiableResolve()
            this.signDialogVisible = false
        },
    }
}